import type { InputHTMLAttributes } from 'react';

type InputFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
};

export function InputField({ label, id, className = '', ...rest }: InputFieldProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <label htmlFor={inputId} className="text-xs font-medium text-text-primary">
        {label}
      </label>
      <input
        id={inputId}
        className="h-10 w-full rounded-md border border-border-default bg-bg-surface px-3 text-[13px] text-text-primary outline-none placeholder:text-text-secondary focus:border-2 focus:border-action-primary focus:px-[11px] focus:shadow-[0_0_0_3px_rgba(37,99,235,0.28)]"
        {...rest}
      />
    </div>
  );
}
